import CloseIcon from "@mui/icons-material/Close";
import TitleCover from "components/shared/TitleCover";
import type { IWorkTitleSummary } from "containers/Works/types";
import { useTranslation } from "react-i18next";

import { titleSubtitle } from "./titleDisplay";

type CoveredTitlesChipProps = {
    title: IWorkTitleSummary;
    onRemove: (titleId: number) => void;
};

const CoveredTitlesChip = ({ title, onRemove }: CoveredTitlesChipProps) => {
    const [t] = useTranslation();
    const subtitle = titleSubtitle(title, t("Works.Ean13"));

    return (
        <span className="covered-titles-chip">
            <span className="covered-titles-chip-cover">
                <TitleCover coverUrl={title.avatarUrl ?? undefined} title={title.name} color="title-color" />
            </span>
            <span className="covered-titles-chip-text">
                <span className="covered-titles-chip-name">{title.name}</span>
                {subtitle ? <span className="covered-titles-chip-meta">{subtitle}</span> : null}
            </span>
            <button
                type="button"
                className="covered-titles-chip-remove"
                onClick={() => onRemove(title.id)}
                aria-label={t("ConnectTitle.CoveredTitlesRemove", { name: title.name })}
            >
                <CloseIcon sx={{ fontSize: 14 }} />
            </button>
        </span>
    );
};

export default CoveredTitlesChip;
